import {AUTH_LOGIN} from '../actions/AuthActions';
import {HYDRATE} from 'next-redux-wrapper';

const INITIAL_STATE = {
    data: null,
    error: null,
    token: null,
    mfa: null,
    mfa_type: null,
    mfa_identifier: null,
    username: null,
    password: null,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        case HYDRATE:
            return {...state, ...action.payload.Auth};

        case AUTH_LOGIN.REQUEST:
            return {
                ...state,
                ...action.payload,
                data: null,
                error: null,
            };

        case AUTH_LOGIN.MFAACTIVE:
            return {
                ...state,
                password: null,
                mfa: true,
                mfa_type: action.payload.mfa_type,
                mfa_identifier: action.payload.mfa_identifier,
                error: null,
            };

        case AUTH_LOGIN.SUCCESS:
            return {
                data: action.payload,
                error: null,
                token: action.payload.access_token
            };

        case AUTH_LOGIN.FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        case AUTH_LOGIN.SET_TOKEN:
            return {
                ...state,
                token: action.payload
            };

        case AUTH_LOGIN.SIGNOUT:
            return {
                ...INITIAL_STATE,
                token: null,
            };

        case AUTH_LOGIN.RESET:
            return {...INITIAL_STATE};

        default:
            return state;
    }
}